import { HOST, APP_LANGUAGE, LANGUAGE } from '../index';


/**
 * @name BASE_API
 * @constant
 * @string
 * @description Base URL for APIs
 */
export const BASE_API = `${ HOST }/cdp/cms/${ APP_LANGUAGE !== 'cn' ? APP_LANGUAGE : LANGUAGE }/`;

/**
 * @name PUBLICATIONS
 * @constant
 * @string
 * @description API for retrieving the PUBLICATIONS
 */
export const PUBLICATIONS = BASE_API + 'listing/analogdialogue-archive.js';
